import { Breadcrumb as ChakraBreadcrumb } from "@chakra-ui/react";
import { FC, Fragment } from "react";
import { Link } from "react-router";

import { FONT_FAMILY, FONT_WEIGHT } from "@assets/theme/foundations/textStyle";
import { ChevronRightIcon } from "@shared/components/Icons";
import { BreadcrumbItemInterface } from "@shared/interfaces";

interface BreadcrumbProps {
  items: BreadcrumbItemInterface[];
}

const Breadcrumb: FC<BreadcrumbProps> = ({ items }) => {
  return (
    <ChakraBreadcrumb.Root gap="0px">
      <ChakraBreadcrumb.List gap="0px">
        {items.map((item, index) => (
          <Fragment key={item.name}>
            {index > 0 && (
              <ChakraBreadcrumb.Separator>
                <ChevronRightIcon color="gray.500" />
              </ChakraBreadcrumb.Separator>
            )}
            <ChakraBreadcrumb.Item>
              <ChakraBreadcrumb.Link
                asChild
                aria-current={item.isCurrentPage ? "page" : undefined}
                fontSize={item.isCurrentPage ? "26px" : undefined}
                fontWeight={item.isCurrentPage ? FONT_WEIGHT.HEAVY : undefined}
                fontFamily={item.isCurrentPage ? FONT_FAMILY.SECONDARY : undefined}
              >
                <Link to={item.to ?? "#"}>{item.name}</Link>
              </ChakraBreadcrumb.Link>
            </ChakraBreadcrumb.Item>
          </Fragment>
        ))}
      </ChakraBreadcrumb.List>
    </ChakraBreadcrumb.Root>
  );
};

export default Breadcrumb;
